import React, { Component } from 'react'
import styled from 'styled-components'
import MealButton from './MealButton'

const RadioGroupContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  ${({ isRadio }) => {
    if (isRadio) {
      return `
        height: 70px;
      `
    }

    return `
      flex-direction: column;
      height: 100%;
    `
  }};
`
export const Check = styled.img`
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-right: 10px;

  @media (max-width: 763px) {
    width: 15px;
    height: 15px;
  }
`
const Container = styled.div`
  height: 70%;
  flex:1;
  font-size: 20px;
  position: relative;
  overflow: hidden;
  display: flex;
  cursor: pointer;
  background-color: ${props => props.isSelected ? '#3b99fc' : '#E0E0E0'};
  margin-left: 4px;
  margin-right: 4px;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  border-radius: 4px;

  @media (max-width: 763px) {
    width: 55px;
  }
`
const Buttons = styled.button`
  color: ${props => props.isSelected ? '#FFF' : '#4A4A4A'};
  background-color: transparent;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  border: solid 0.5px transparent;
`
const Input = styled.input`
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  height: 100%;
  width: 100%;
  font-size: 10px;
  cursor: pointer;
`

class RadioGroup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: null,
    }
  }


  onClick = (e) => {
    let name = e.target.name
    let id = e.target.id
    if (e.target.id !== '') {
      this.setState({selected:e.target.id},() => this.props.setInfo(id,name))
    }
  }

  render() {
    const { children, isRadio } = this.props
    const { selected } = this.state

    return (
      <RadioGroupContainer isRadio={isRadio}>
        {isRadio ?
          children.map(({ props }) => {
            if (!props) {
              return null
            }

            return (
              <Container key={props.label} isSelected={selected == props.label} >
                <Input
                  ref={(input) => { this.clickItem = input }}
                  onClick={this.onClick}
                  id={props.label}
                  name={props.name}
                  type="radio"
                />
                <Buttons
                  onClick={() => this.clickItem.click()}
                  isSelected={selected == props.label}
                >
                  <Check
                    src={selected == props.label ?
                      '/assets/radiochecked.svg' :
                      '/assets/radiocheckmark.svg'}
                    checked={selected == props.label}
                  />
                  {props.type}
                </Buttons>
              </Container>
            )
          }) :
          children.map(({ props }, index) => {
            if (!props) {
              return null
            }

            const isSelected = selected === props.label || index + 1 === props.selected

            return (
              <MealButton
                id={props.label}
                key={props.label}
                label={props.label}
                name={props.name}
                icon={isSelected ? '/assets/check.svg' : null}
                isSelected={isSelected}
                onClick={this.onClick}
              />
            )
          })
        }
      </RadioGroupContainer>
    )
  }
}

export default RadioGroup



// WEBPACK FOOTER //
// ./src/Components/CustomButtons/RadioGroup.jsx